import { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from './authStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Clear synchronously before a new identity can render another user's queries.
useAuthStore.subscribe((state, previous) => {
  if (state.user?.id !== previous.user?.id) queryClient.clear();
});
